import { Store } from '~/lib/data-contract/salesforce';

type Props = {
    stores: Store[];
    searchQuery: string;
    minSearchQueryLength?: number;
};

export const filterStores = ({ stores = [], searchQuery, minSearchQueryLength = 2 }: Props) => {
    const trimmedQuery = searchQuery?.trim();
    if (!trimmedQuery || trimmedQuery.length < minSearchQueryLength) {
        return stores;
    }

    const normalize = (text: string) => text.toLowerCase().replace(/å/g, 'aa');
    const normalizedQueryWords = trimmedQuery.split(/\s+/).filter(Boolean).map(normalize);

    return stores.filter((store) => {
        // Combine all searchable text
        const searchableText = normalize(`${store.city} ${store.postalCode} ${store.name || ''}`);

        // Check if ALL search words are found anywhere in the searchable text
        return normalizedQueryWords.every((word) => searchableText.includes(word));
    });
};

// Removes teh city area from the city name fx NV, C, NØ, SØ, SV etc so the city names cane be faltered and compared
export const trimCityArea = (str: string = '') => {
    const lastSpaceIndex = str.lastIndexOf(' ');

    if (lastSpaceIndex !== -1 && str.length - lastSpaceIndex - 1 <= 2) {
        return str.substring(0, lastSpaceIndex);
    }

    return str || '';
};
